import React from 'react';

import {NutritionAvatar} from 'ccm/art/MedicalIcons';
import InfoCard from './InfoCard';

export default function ContactsCard(props) {
    return (
        <InfoCard
            color='blue'
            Avatar={NutritionAvatar}
            title='Nutrition Orders'
            {...props}
        ></InfoCard>
    );
}
